<template>
	<v-container fluid class="auth-page">
		<v-container class="auth-shell">
			<v-card elevation="0" class="auth-card rounded-xl">
				<v-container class="auth-form-panel">
					<div class="auth-logo-wrap">
						<img
							src="@/assets/mtl-cargo-logo-2.png"
							class="auth-logo"
						/>
					</div>
						<div class="auth-form-header">
							<div class="auth-eyebrow">Sign In</div>
							<h2>Login</h2>
							<p>Use your account email and password.</p>
						</div>

						<v-form v-model="isFormValid" ref="form">
							<v-text-field
								dense
								rounded
								outlined
								:rules="emailRules"
								label="Email"
								v-model="email"
								v-on:keyup.enter="login()"
								prepend-inner-icon="mdi-email-outline"
								required
							></v-text-field>
							<v-text-field
								dense
								rounded
								outlined
								:rules="passRules"
								type="password"
								label="Password"
								v-model="password"
								v-on:keyup.enter="login()"
								prepend-inner-icon="mdi-lock-outline"
								required
							></v-text-field>
						</v-form>

						<v-btn
							block
							class="auth-primary-btn"
							color="primary"
							depressed
							rounded
							@click="login"
							:disabled="!isFormValid"
							:loading="isLoading"
						>
							<i class="fas fa-sign-in-alt mr-2"></i>
							Login
						</v-btn>

						<div class="auth-switch">
							<span>Need an account?</span>
							<v-btn
								text
								small
								color="primary"
								@click="
									$router
										.push({ name: 'UserRegister' })
										.catch(() => {})
								">
								Register
							</v-btn>
						</div>
				</v-container>
			</v-card>
		</v-container>
	</v-container>
</template>
<script>
import eventBus from "@/js/event-bus.js";
import backendService from "@/services/backend-service.js";
import formMixin from "@/js/form-mixin.js";
import generalMixin from "@/js/general-mixin";
export default {
	name: "LoginPage",
	mixins: [formMixin, generalMixin],
	data() {
		return {};
	},
	computed: {},
	methods: {
		login() {
			if (!this.$refs.form.validate()) {
				return;
			}
			let loginInfo = {};
			loginInfo.email = this.email;
			loginInfo.password = this.password;
			this.isLoading = true;
			backendService
				.login(loginInfo)
				.then((response) => {
					localStorage.setItem(
						"userInfo",
						JSON.stringify(response.data.userInfo)
					);
					localStorage.setItem(
						"isAdmin",
						response.data.userInfo.isAdmin
					);
					localStorage.setItem(
						"isRoot",
						response.data.userInfo.isRoot
					);
					localStorage.setItem("sessionId", response.data.id);
					localStorage.setItem("cart", JSON.stringify({}));
					localStorage.setItem("cartCount", 0);
					localStorage.setItem("token", response.data.token);
					this.$store.commit(
						"setCurrentUser",
						response.data.userInfo
					);
					if (response.data.userInfo.isAdmin) {
						this.$store.dispatch("getDropdownToOptions");
					}
					this.timer(1000).then(() => {
						this.$router.push({ name: "HomePage" });
						this.isLoading = false;
					});
				})
				.catch(() => {
					this.timer(1000).then(() => {
						eventBus.$emit(
							"setSnackbar",
							"Incorrect Username or Password",
							"red darken-1 white--text",
							true
						);
						this.isLoading = false;
					});
				});
		},
	},
};
</script>
<style scoped>
.auth-page {
	align-items: center;
	display: flex;
	min-height: calc(100vh - 128px);
	padding: 24px 12px;
}
.auth-shell {
	max-width: 440px;
	padding: 0;
}
.auth-card {
	overflow: hidden;
}
.auth-form-header p {
	font-size: 15px;
	line-height: 1.55;
	margin: 0;
}
.auth-eyebrow {
	color: #f6a03d;
	font-size: 13px;
	font-weight: 700;
	letter-spacing: 0;
	text-transform: uppercase;
}
.auth-form-panel {
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 34px 36px 32px;
}
.auth-logo-wrap {
	display: flex;
	justify-content: center;
	margin-bottom: 24px;
}
.auth-logo {
	max-width: 154px;
	width: 54%;
}
.auth-form-header {
	text-align: center;
	margin-bottom: 24px;
}
.auth-form-header h2 {
	color: #172033;
	font-size: 28px;
	font-weight: 650;
	line-height: 1.2;
	margin: 6px 0 8px;
}
.auth-form-header p,
.auth-switch {
	color: #667085;
}
.auth-primary-btn {
	height: 42px !important;
	margin-top: 4px;
}
.auth-switch {
	align-items: center;
	display: flex;
	font-size: 14px;
	justify-content: center;
	margin-top: 18px;
}
@media (max-width: 959px) {
	.auth-page {
		min-height: auto;
	}
	.auth-form-panel {
		padding: 30px 22px;
	}
}
</style>
